export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  INBOX_VIEW: 'inbox_view',
  SLA: 'sla',
  RESPONSE_BOT: 'response_bot',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_TWITTER: 'channel_twitter',
  CHANNEL_WEBSITE: 'channel_website',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
  IP_LOOKUP: 'ip_lookup',
  JIRA: 'jira_integration',
  LINEAR: 'linear_integration',
  CAPTAIN: 'captain_integration',
  CLAUDIA: 'claudia',
  CLAUDIA_EVENTS: 'claudia_events',
  CUSTOM_ROLES: 'custom_roles',
  OPEN_AI_ASSISTANCE: 'open_ai_assistance',
  MERGE_CONVERSATIONS: 'merge_conversations',
  PREVIOUS_CONVERSATION_PEEK: 'previous_conversation_peek',
};

// Redis-based feature flags (checked differently from YAML-based ones)
export const REDIS_FEATURE_FLAGS = {
  CLAUDIA: 'claudia',
  CLAUDIA_AGENTS_V2: 'claudia_agents_v2',
  CLAUDIA_EVENTS: 'claudia_events',
  CLAUDIA_ONLY: 'claudia_only',
  CLAUDIA_SETTINGS: 'claudia_settings',
  CLAUDIA_DEPLOY: 'claudia_deploy',
  AGENT_STUDIO_VIEW: 'agent_studio_view',
  SUPERVISOR_SKILLS: 'supervisor_skills',
  OMNI_SERVICE_TIME_METRICS_REPORT: 'omni_service_time_metrics_report',
  OMNI_CAMPAIGN_METRICS_REPORT: 'omni_campaign_metrics_report',
  OMNI_CSAT_REPORT: 'omni_csat_report',
  OMNI_CONVERSATIONS_REPORT: 'omni_conversations_report',
  OMNI_AGENTS_REPORT: 'omni_agents_report',
  OMNI_TEAMS_REPORT: 'omni_teams_report',
  TEAM_SETTING_OVERRIDES: 'team_setting_overrides',
  // Settings > Billing: the tenant's estimated invoice, from backoffice-api.
  // Per-account opt-in; surfaced by Account#enabled_features_with_redis_flags.
  BILLING_ESTIMATE: 'billing_estimate',
  CONVERSATION_QUICK_FILTERS_BETA: 'conversation_quick_filters_beta',
  DISABLE_SECTION_QUICK_FILTER: 'disable_section_quick_filter',
  DISABLE_SECTION_ADVANCED_FILTER: 'disable_section_advanced_filter',
  MULTIPLE_CONTENT_TAGS: 'multiple_content_tags',
  SLACK_CHANNEL: 'slack_channel',
  LINKEDIN_CHANNEL: 'linkedin_channel',
  CHANNEL_VOICE: 'channel_voice',
  VOICE_RECORDING_DOWNLOAD: 'voice_recording_download',
  VOICE_TRANSCRIPTION: 'voice_transcription',
  PARALLEL_CONVERSATIONS: 'parallel_conversations',
  FILTERED_AUTO_REFRESH_PAUSED: 'filtered_auto_refresh_paused',
  KANBAN_STAGE_BOARD: 'kanban_stage_board',
  BULK_SELECTION_BY_FILTER: 'bulk_selection_by_filter',
};

// CSV_AUDIENCE_V2_GATE — #967 CSV audience v2 kill-switch (custom_attributes.feature_flags,
// read via isNewFeatureFlagEnabled). Remove with the gate.
export const CSV_AUDIENCE_V2_FLAG = 'csv_audience_v2';
